/**
 * LoginIcon 컴포넌트 - 로그인 SVG 아이콘
 *
 * 구조:
 * - SVG 기반 벡터 아이콘
 * - 20x20px 고정 크기
 * - currentColor로 부모 요소 색상 상속
 *
 * 애니메이션:
 * - CSS hover 효과 (hover-primary 클래스)
 *
 * Props:
 * - tailwind?: string - 추가 Tailwind CSS 클래스
 */
export function LoginIcon({ tailwind }: { tailwind?: string }) {
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 20 20"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            className={`hover-primary ${tailwind}`}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.104 2.696A2.404 2.404 0 0 0 15.412 2H8.646c-.634 0-1.243.25-1.693.696a2.376 2.376 0 0 0-.704 1.687v.634a.75.75 0 0 0 1.5 0v-.634c0-.232.093-.456.26-.622a.904.904 0 0 1 .637-.261h6.764c.24 0 .47.095.637.26.168.167.26.391.26.623v11.234a.877.877 0 0 1-.26.622.904.904 0 0 1-.636.261H8.646a.904.904 0 0 1-.637-.26.877.877 0 0 1-.26-.623v-1.015a.75.75 0 1 0-1.5 0v1.015c0 .634.254 1.24.704 1.687.45.446 1.06.696 1.693.696h6.764c.634 0 1.243-.25 1.693-.696.45-.446.705-1.053.705-1.687V4.383c0-.634-.255-1.24-.705-1.687Zm-6.98 10.34a.75.75 0 0 0 1.06-.045l2.25-2.45a.75.75 0 0 0 0-1.015l-2.25-2.45a.75.75 0 0 0-1.105 1.015l1.096 1.192H2.75a.75.75 0 1 0 0 1.5h8.425l-1.096 1.193a.75.75 0 0 0 .045 1.06Z"
                fill="currentColor"
            ></path>
        </svg>
    );
}
